module.exports = __webpack_public_path__ + "img/09.9203a695.webp";